import { useTranslation } from "react-i18next";
import Table from "../../../components/Common/dataTable/index";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
interface ExpenseCategoriesTableProps {
  dataSource: any[];
  onEdit: (record: any) => void;
  onDelete: (id: string) => void;
  loading: boolean;
}
const { confirm } = Modal;

const ExpenseCategoriesTable = ({
  dataSource,
  onEdit,
  onDelete,
  loading,
}: ExpenseCategoriesTableProps) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("name"),
      dataIndex: "name",
    },
    {
      title: t("description"),
      dataIndex: "description",
      render: (text: string) =>
        text?.length > 50 ? `${text.substring(0, 50)}...` : text || "-",
    },
    {
      title: t("actions"),
      dataIndex: "actions",
      render: (_: any, record: any) => {
        const actions: Action[] = [
          {
            label: t("edit"),
            icon: "ti ti-edit",
            actionType: "link",
            onClick: () => onEdit(record),
          },
          {
            label: t("delete"),
            icon: "ti ti-trash",
            actionType: "link",
            onClick: () => showDeleteConfirm(record.id),
          },
        ];
        return <ActionsDropdown actions={actions} />;
      },
    },
  ];

  const showDeleteConfirm = (id: string) => {
    confirm({
      title: t("are_you_sure_you_want_to_delete_this_expense_category?"),
      icon: <ExclamationCircleOutlined />,
      content: t("this_action_cannot_be_undone"),
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      okButtonProps: { disabled: loading },
      onOk: () => onDelete(id),
    });
  };

  return (
    <div className="mt-4">
      <div className="table-responsive">
        <Table
          columns={columns}
          dataSource={dataSource}
          Selection={false}
          pagination={true}
        />
      </div>
    </div>
  );
};

export default ExpenseCategoriesTable;
